module.exports = __webpack_public_path__ + "static/media/historic_icsp_marker_hover.9050b38a.svg";